import React from 'react'
import '../../styles/skeletons.css'

// Base shimmer skeleton block
export function Skeleton({ width = '100%', height = 16, radius = 6, style }) {
  return (
    <div
      className="skeleton-shimmer"
      style={{ width, height, borderRadius: radius, ...style }}
    />
  )
}

// Card skeleton (matches .card layout)
export function SkeletonCard({ lines = 3 }) {
  return (
    <div className="skeleton-card">
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
        <Skeleton width={40} height={40} radius={10} />
        <div style={{ flex: 1 }}>
          <Skeleton height={14} width="60%" style={{ marginBottom: 6 }} />
          <Skeleton height={11} width="40%" />
        </div>
      </div>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} height={12} width={i === lines - 1 ? '70%' : '100%'} style={{ marginBottom: 8 }} />
      ))}
    </div>
  )
}

// Stat card skeleton (matches KPI card)
export function SkeletonStat() {
  return (
    <div className="skeleton-card">
      <Skeleton height={11} width="50%" style={{ marginBottom: 12 }} />
      <Skeleton height={28} width="65%" style={{ marginBottom: 8 }} />
      <Skeleton height={11} width="40%" />
    </div>
  )
}

// Table row skeleton
export function SkeletonTableRow({ cols = 5 }) {
  const widths = ['40%', '25%', '20%', '15%', '10%']
  return (
    <div className="skeleton-table-row">
      {Array.from({ length: cols }).map((_, i) => (
        <Skeleton key={i} height={13} width={widths[i] || '20%'} />
      ))}
    </div>
  )
}

// Site/client card grid skeleton
export function SkeletonGrid({ count = 6, cols = 3 }) {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: `repeat(${cols}, 1fr)`, gap: 16 }}>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="skeleton-card">
          <Skeleton height={120} radius={10} style={{ marginBottom: 12 }} />
          <Skeleton height={14} width="70%" style={{ marginBottom: 6 }} />
          <Skeleton height={11} width="50%" style={{ marginBottom: 12 }} />
          <div style={{ display: 'flex', gap: 8 }}>
            <Skeleton height={10} width={60} radius={12} />
            <Skeleton height={10} width={50} radius={12} />
          </div>
        </div>
      ))}
    </div>
  )
}

// Generic empty state
export function EmptyState({ icon, title, description, action, actionLabel }) {
  return (
    <div className="empty-state">
      {icon && <div className="empty-state-icon">{icon}</div>}
      <div className="empty-state-title">{title}</div>
      {description && <div className="empty-state-desc">{description}</div>}
      {action && (
        <button className="ds-btn" style={{ marginTop: 16, padding: '8px 20px', background: 'var(--accent)', color: '#fff', border: 'none', borderRadius: 10, cursor: 'pointer', fontSize: 13, fontWeight: 600 }} onClick={action}>
          {actionLabel || 'Get started'}
        </button>
      )}
    </div>
  )
}

// Error state
export function ErrorState({ message = 'Something went wrong', onRetry }) {
  return (
    <div className="empty-state">
      <div className="empty-state-icon" style={{ color: '#ef4444' }}>
        <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="9"/><path d="M12 8v4M12 16h.01"/>
        </svg>
      </div>
      <div className="empty-state-title">Error</div>
      <div className="empty-state-desc">{message}</div>
      {onRetry && (
        <button className="ds-btn" style={{ marginTop: 16, padding: '8px 20px', background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 10, cursor: 'pointer', fontSize: 13 }} onClick={onRetry}>
          Try again
        </button>
      )}
    </div>
  )
}
